import React, { forwardRef } from "react";
import ConditionalFragment from "../ConditionalFragment";
import classNames from "classnames";

type OwnProps = {
  placeholder?: string;
  label?: string;
  inputMode?: ElementProps<"input">["inputMode"];
  maxLength?: number;
  minLength?: number;
  required?: boolean;

  onChange?: (...event: any[]) => void;
  onBlur?: () => void;
  value?: any;
  name: string;
  error?: string | void;
  touched?: boolean | void;
  disabledBorder?: boolean;
};

type Props = OwnProps & Partial<ElementProps<"input">>;

const TextFields: React.FC<Props> = ({ label, required, ...props }) => {
  return (
    <div className={"flex flex-col mb-6"}>
      <label className={"mb-2 text-sm text-grey-2"}>
        {label}
        <ConditionalFragment condition={!!required}>
          <span className={"text-red"}>*</span>
        </ConditionalFragment>
      </label>
      <Input {...props} />
    </div>
  );
};

export const Input = forwardRef<
  HTMLInputElement,
  Omit<Props, "label" | "required">
>(
  (
    {
      placeholder,
      onBlur,
      onChange,
      value,
      name,
      inputMode,
      maxLength,
      minLength,
      error,
      touched,
      disabledBorder,
      className,
      ...rest
    },
    ref
  ) => {
    return (
      <React.Fragment>
        <input
          ref={ref}
          className={classNames(
            className,
            "w-full px-4 py-3 rounded-lg",
            disabledBorder ? "" : "border border-grey-6"
          )}
          placeholder={placeholder}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          name={name}
          inputMode={inputMode}
          maxLength={maxLength}
          minLength={minLength}
          autoCorrect="off"
          autoCapitalize="off"
          {...rest}
        />
        {touched && error && (
          <span className={"text-xs text-red"}>{error}</span>
        )}
      </React.Fragment>
    );
  }
);

export default TextFields;
